import React, { type PropsWithChildren } from 'react';

export const SerifText: React.FC<PropsWithChildren> = (props) => {
  // some extra pixels to compensate for shorter serif font
  return <span className='font-serif text-[calc(100%+4px)] !font-normal'>{props.children}</span>;
};
